// @unocss-include

export const devPrompts = [
  { text: 'How do I center a div?' },
  { text: 'Build a todo app', prompt: 'Build a very minimal todo app. No database, no auth.' },
];

export const examplePrompts = [
  { text: 'Create a financial app', href: '/~/financial-app', slug: 'financial-app' },
  { text: 'Design a directory website', href: '/~/directory-website', slug: 'directory-website' },
  { text: 'Build a project management app', href: '/~/app-project-management', slug: 'app-project-management' },
  { text: 'Make a landing page', href: '/~/payment-app', slug: 'payment-app' },
  { text: 'Generate a CRM', href: '/~/personal-crm', slug: 'personal-crm' },
];
